/**
 * Onboarding API — paths, assign, progress, steps (start, complete, submitTest, unblock).
 */

import { apiFetch } from './core'

export const onboarding = {
    listPaths: (department) => apiFetch(`/onboarding/paths${department ? `?department=${encodeURIComponent(department)}` : ''}`),
    getPath: (id) => apiFetch(`/onboarding/paths/${id}`),
    createPath: (data) => apiFetch('/onboarding/paths', { method: 'POST', body: JSON.stringify(data) }),
    updatePath: (id, data) => apiFetch(`/onboarding/paths/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
    addStep: (pathId, data) => apiFetch(`/onboarding/paths/${pathId}/steps`, { method: 'POST', body: JSON.stringify(data) }),
    // Шаг не удаляют, а выключают (`is_active: false`): на нём висят строки
    // прогресса сотрудников, и удаление снесло бы им пройденные этапы.
    updateStep: (stepId, data) => apiFetch(`/onboarding/steps/${stepId}`, { method: 'PATCH', body: JSON.stringify(data) }),
    materials: (q) => apiFetch(`/onboarding/materials${q ? `?q=${encodeURIComponent(q)}` : ''}`),
    pathAssignees: (pathId) => apiFetch(`/onboarding/paths/${pathId}/assignees`),
    assignPath: (pathId, employeeId) => apiFetch(`/onboarding/paths/${pathId}/assign/${employeeId}`, { method: 'POST' }),
    getProgress: (employeeId) => apiFetch(`/onboarding/my-progress/${employeeId}`),
    teamProgress: (department) => apiFetch(`/onboarding/team-progress?department=${encodeURIComponent(department)}`),
    startStep: (stepId, employeeId) => apiFetch(`/onboarding/steps/${stepId}/start?employee_id=${employeeId}`, { method: 'POST' }),
    completeStep: (stepId, employeeId) => apiFetch(`/onboarding/steps/${stepId}/complete?employee_id=${employeeId}`, { method: 'POST' }),
    submitTest: (stepId, employeeId, answers) => apiFetch(`/onboarding/steps/${stepId}/submit-test?employee_id=${employeeId}`, {
        method: 'POST', body: JSON.stringify({ answers }),
    }),
    unblockStep: (stepId, employeeId, action = 'retry') => apiFetch(
        `/onboarding/steps/${stepId}/unblock?employee_id=${employeeId}&action=${action}`,
        { method: 'POST' },
    ),
}
